import React, { forwardRef } from 'react'
import clsx from 'clsx'
import './index.scss'

const variants = {
	plain: 'button',
	ghost: 'button button--ghost',
	outline: 'button button--outline',

	primary: 'button button--primary',
	secondary: 'button button--secondary',
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant: keyof typeof variants
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function (
	{ className, variant, ...rest },
	ref,
) {
	return (
		<button
			className={clsx(variants[variant], className)}
			{...rest}
			ref={ref}
		/>
	)
})
